// Utilidades compartilhadas do Calendário de Alertas
export const ALERT_CATEGORIES = [
  { value: 'seguro', label: 'Seguro', icon: '🛡️' },
  { value: 'registro', label: 'Registro/Licença', icon: '🔖' },
  { value: 'manutencao', label: 'Manutenção', icon: '🔧' },
  { value: 'pagamento', label: 'Pagamento', icon: '💰' },
  { value: 'documento', label: 'Documento', icon: '📄' },
  { value: 'outro', label: 'Outro', icon: '📌' },
];

export const ALERT_PRIORITIES = [
  { value: 'baixa', label: 'Baixa', cls: 'bg-slate-100 text-slate-600' },
  { value: 'media', label: 'Média', cls: 'bg-blue-100 text-blue-700' },
  { value: 'alta', label: 'Alta', cls: 'bg-amber-100 text-amber-700' },
  { value: 'urgente', label: 'Urgente', cls: 'bg-red-100 text-red-700' },
];

export const ALERT_RECURRENCES = [
  { value: 'none', label: 'Não repetir' },
  { value: 'monthly', label: 'Mensal' },
  { value: 'quarterly', label: 'Trimestral' },
  { value: 'semiannual', label: 'Semestral' },
  { value: 'annual', label: 'Anual' },
  { value: 'custom', label: 'A cada X meses' },
];

export const recurrenceLabel = (value, interval) => {
  if (!value || value === 'none') return null;
  if (value === 'custom') {
    const n = interval || 1;
    return `A cada ${n} ${n === 1 ? 'mês' : 'meses'}`;
  }
  return (ALERT_RECURRENCES.find((r) => r.value === value) || {}).label || null;
};

// Origem do item na visão unificada
export const SOURCE_META = {
  alert: { label: 'Alerta', cls: 'bg-indigo-100 text-indigo-700' },
  bill: { label: 'Conta a pagar', cls: 'bg-orange-100 text-orange-700' },
  company_alert: { label: 'Validade', cls: 'bg-teal-100 text-teal-700' },
};

export const catMeta = (value) => ALERT_CATEGORIES.find((c) => c.value === value) || ALERT_CATEGORIES[5];
export const prioMeta = (value) => ALERT_PRIORITIES.find((p) => p.value === value) || ALERT_PRIORITIES[1];

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try {
    const [y, m, d] = iso.split('-');
    return `${d}/${m}/${y}`;
  } catch { return iso; }
};

export function urgencyBadge(a) {
  const du = a.days_until;
  if (a.status === 'resolvido') return { cls: 'bg-emerald-100 text-emerald-700', text: 'Resolvido' };
  if (du === null || du === undefined) return { cls: 'bg-slate-100 text-slate-600', text: '—' };
  if (du < 0) return { cls: 'bg-red-100 text-red-700', text: `Vencido há ${Math.abs(du)}d` };
  if (du === 0) return { cls: 'bg-red-100 text-red-700', text: 'Hoje' };
  if (a.urgency === 'soon') return { cls: 'bg-amber-100 text-amber-700', text: `Em ${du}d` };
  return { cls: 'bg-slate-100 text-slate-600', text: `Em ${du}d` };
}

export const categoryLabel = (a) => {
  if (a.category === 'outro' && a.custom_category) return `📌 ${a.custom_category}`;
  const m = catMeta(a.category);
  return `${m.icon} ${m.label}`;
};
